import { Component, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { Inject } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";

@Component( {
    selector: 'app-info-dialog',
    templateUrl: './info-dialog.component.html',
    styleUrls: ['./info-dialog.component.scss']
} )
export class InfoDialogComponent implements OnInit {

    constructor( @Inject( MAT_DIALOG_DATA ) public data,
        public dialogRef: MatDialogRef<InfoDialogComponent> ) { }

    ngOnInit() {
    }

    closeDialog() {
        this.dialogRef.close( false );
    }
}
